import type { PartialPetition } from 'src/app/pages/petitionGamma/api/petition';

export function isCommentsEnabled(petition: PartialPetition): boolean {
	return !petition.shouldHideUserActions;
}
